import axios from 'axios';

export const reportService = {
  getARAging: async (params = {}) => {
    const response = await axios.get('/api/reports/ar-aging', { params });
    return response.data;
  },
  getSalesSummary: async (params = {}) => {
    const response = await axios.get('/api/reports/sales-summary', { params });
    return response.data;
  }
};
